import { combineReducers } from "@reduxjs/toolkit";
import utilsReducer from "./utilsSlice.js";
import userReducer from "./userSlice.js";
import mallsReducer from "./mallsSlice.js";
import restaurantsReducer from "./restaurantsSlice.js";
import ordersReducer from "./ordersSlice.js";
import promoCodesReducer from "./promoCodesSlice.js";

const rootReducer = combineReducers({
  utils: utilsReducer,
  user: userReducer,
  malls: mallsReducer,
  restaurants: restaurantsReducer,
  orders: ordersReducer,
  promoCodes: promoCodesReducer,
});

export default rootReducer;